<script lang="ts" setup>
const { LocalConfigurationStore } = stores()
</script>

<template>
  <LayoutContainer
    v-if="LocalConfigurationStore?.brokerContext?.context.id"
    class="z-10 bg-primary-500 py-4"
  >
    <div class="grid gap-24">
      <div class="flex justify-between text-center md:justify-between">
        <a :href="LocalConfigurationStore.brokerContext.brokerWebsite">
          <img
            :src="LocalConfigurationStore?.brokerContext?.context.logoUrl"
            :alt="LocalConfigurationStore?.brokerContext?.context.brokerName"
            class="h-8 lg:h-10"
          />
        </a>
        <img
          src="/public/img/powered-by-contigo.png"
          alt="Contigo"
          class="h-8 lg:h-10"
        />
      </div>
    </div>
  </LayoutContainer>
</template>
